import React from 'react'

import FormManager from "../../../../gd-form/common/form-manager"
import VScroll from "../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import FormAddDeprecated from "../../../../gd-form/form/deprecated/form-add/form-add"
import Input from '../../../../gd-form/form-element/input/input'
import FormError from "../../../../gd-form/common/form-error/form-error"
import CopyOption from "../copy-project/copy-options/copy-option"
import {Copy_Manager} from "../../model/manager"
import {ModalCopy_CopyOption} from "../../@types"
import {CopyGoal_Manager} from "../../model/copy-goal-manager"
import {ButtonType} from "../../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import Modal_Submit from "../../../components/submit/submit"

type Props = {
    manager : Copy_Manager
}

export default function ModalCopy_Goal(props: Props) {

    const manager = props.manager as CopyGoal_Manager

    const onSubmit = (result: any) => {
        manager.commitCopy(result)
    }

    const copyOptions: ModalCopy_CopyOption[] = [
        {id: "copySubGoals",    title: "Subgoals"},
        {id: "copyProgress",    title: "Progress"},
        {id: "copyUsers",       title: "Users"},
    ]

    const initFormData = {
        title: manager.goalToCopy.name + " - copy",
        copyOptions: ["copySubGoals"/*,"copyProgress","copyUsers"*/]
    }

    const formStructure = {
        isFormChanged   : true,
        fields          : {
            title           : {
                type            : 'select',
                isRequired      : true,
            },
            copyOptions     : {
                type            : 'select',
                isRequired:      false,
            }
        },
        onSubmit        : onSubmit
    }

    const form: FormManager = new FormManager(formStructure,initFormData);

    const onCopyOptionSelect = (id: string) => {
        let newSelectedOptions = form.getValue('copyOptions')
        newSelectedOptions = gd.utils.toggleArrayValue(newSelectedOptions,id)
        form.setValue('copyOptions', newSelectedOptions)
    }

    const selectedOptions = form.getValue('copyOptions');

    return (
        <div className="flex-column-top-stretch flex-1 min-h-0">
            <FormAddDeprecated className  = "flex-row-left-top flex-1"
                               style      = {{height: 'calc(100% - 50px - 90px)'}}
                               form       = {form}
                               showSubmit = {false}>
                <VScroll>
                    <div className="tbl">
                        <div className="row">
                            <div className="label">Goal title</div>
                            <div className="element">
                                <Input size="big" form={form} name="title"/>
                                <FormError form={form} name="title"/>
                            </div>
                        </div>

                        <div className="row">
                            <div className="label">Copy</div>
                            <div className="element">
                                {_.map(copyOptions, option=>
                                    <CopyOption key         = {option.id}
                                                id          = {option.id}
                                                title       = {option.title}
                                                selected    = {selectedOptions.includes(option.id)}
                                                onSelect    = {onCopyOptionSelect}/>)}
                            </div>
                        </div>
                    </div>
                </VScroll>
            </FormAddDeprecated>

            <Modal_Submit type      = {ButtonType.PRIMARY}
                          label     = "Copy"
                          onSubmit  = {()=>{form.onSubmitClick()}}/>
        </div>

    )
}